import { HEADER_CLICK_IDS } from '../../types';
import { sendReward } from '@dx-ui/framework-conductrics';
import { dispatchGlobalNavigationClick, sendInteractionReward } from '../../header.utilities';
import Icon from '@dx-ui/osc-icon';
import { Link } from '@dx-ui/global-ui-prism';
import { useTranslation } from 'next-i18next';
import { useHeaderContext } from '../../context/header-context';
import { useHeaderStateContext } from '../../context/header-state-context';

export const MobileBottomFindYourStayLink = () => {
  const { t } = useTranslation(['osc-header', 'osc-login']);
  const {
    features: { shouldSuppressFindStay, shouldOpenAccountLinksInNewWindow },
    navigation: { onGlobalNavigationClick, isLegacyGlobalNavigationClickAnalyticsEnabled = true },
  } = useHeaderContext();
  const { activeUserLinks: links } = useHeaderStateContext();

  if (!links?.findStayLink || shouldSuppressFindStay) return null;

  return (
    <Link
      colorTheme="inherit"
      url={links.findStayLink.url}
      isNewWindow={shouldOpenAccountLinksInNewWindow}
      underline={false}
      onClick={() => {
        sendInteractionReward();
        sendReward('find-stay-click');
        dispatchGlobalNavigationClick(
          HEADER_CLICK_IDS.FindStay,
          onGlobalNavigationClick,
          isLegacyGlobalNavigationClickAnalyticsEnabled
        );
      }}
      anchorClassName="text-center align-middle"
      showNewWindowIcon={false}
    >
      <>
        <Icon name="calendar-search" size="md" className="m-auto block" />
        <span className="text--sm inline-block font-semibold">{t('yourStays')}</span>
      </>
    </Link>
  );
};
